/**
 * Private event name for localized change events dispatched to a custom element host root.
 * This constant should only be used for constructing an instance of the private event and for
 * creating listeners on a host root. End users should not need access to this name or the
 * related events.
 *
 * TODO: When all browsers support Symbols as event names, change this to a Symbol
 */
export const privateChangeEvent = 'fs-private-choice-button-change';
/**
 * Constructing class for a private change event for choice buttons allowing them to emulate
 * radio-like changes of components with common names in a given root. This event should not
 * be used or relied upon outside of the context of the choice button class itself.
 */
export class PrivateChangeEvent extends Event {
    constructor(checkedChoiceButton) {
        super(privateChangeEvent, {
            bubbles: false,
            cancelable: false,
            composed: false
        });
        this.checkedChoiceButton = checkedChoiceButton;
    }
}
//# sourceMappingURL=privateChangeEvent.js.map